import { isObj } from '@/utils/tool'
import { getLocation } from './ssrCompatible'
import { locale } from '@/utils/utils'
import { globalVariable } from '@/utils/exportVariable'
import { isArray } from '@/utils/tool'

// 特殊处理url问号的链接
function fixDecodeSource(_props) {
  try {
    let sym = '?'
    let decodeParams = decodeURIComponent(_props)
    const items = decodeParams.split(sym)
    if (items.length > 1) {
      return decodeParams.split(sym)[0]
    }
    return items.toString()
  } catch (error) {
    return _props
  }
}

// 接口请求前埋点
export function apiRequestBeforeTrack(config) {
  const token = config.headers['Kicoin-Token']
  let apiRequestTrackOptions = {
    country: config.headers['country'],
    language: config.headers['language'],
    'kachi-end': config.headers['kachi-end'],
    'Kicoin-Token': (token + '').slice(-100),
    'Login-Time': config.headers['Login-Time'],
    url: config.url,
    baseURL: config.baseURL,
  }
  if (isObj(config.data)) {
    apiRequestTrackOptions['body-country'] = config.data.country || 'none'
    apiRequestTrackOptions['body-sign'] = config.data.sign || 'none'
    apiRequestTrackOptions['countryIsEqual'] =
      config.headers['country'] == config.data.country
  }
  // track_ga('request_before', apiRequestTrackOptions)
}

// todo 针对原神US、做单独处理传递 en_US
export function headersLanguageHack() {
  const _location = getLocation()
  let result = locale()

  if (_location.pathname && _location.pathname.indexOf('genshin-en') !== -1) {
    result = 'en_US'
  }

  return result
}

// 用apm上报服务端报错
export function apmTrackServerError(options = {}) {
  const { $apm = {} } = globalVariable
  const { code = 500, message = '', extraInfos = {} } = options
  const {
    method,
    params,
    data,
    baseURL = '',
    url = '',
    headers = {},
  } = extraInfos
  const errorMsg = `<<<服务端接口报错>>>: code=${code};url=${baseURL}${url};message=${message};params=${
    method === 'get' ? JSON.stringify(params) || '' : JSON.stringify(data) || ''
  };headers=${JSON.stringify(headers)}`
  $apm.captureError && $apm.captureError(new Error(errorMsg))
}

// 错误埋点
export function errorTrack() {}
// 接口请求时间埋点
export function apiRequestTimeTrack() {}

//  对接口上要传的source进行修正处理，由于存在多个source的情况，拿到是一个数组，这部分需要做处理
export function fixSource(datas = {}, prop = 'source') {
  if (datas[prop]) {
    if (typeof datas[prop] === 'string') {
      datas[prop] = fixDecodeSource(datas[prop])
      return datas
    }
    if (isArray(datas[prop])) {
      const index = datas[prop].length - 1
      datas[prop] = datas[prop][index]
      return datas
    }
  }
  return datas
}

export function getClientVersion() {
  const {
    version = '',
    buildTime = '',
    commitId = '',
  } = require('../../package.json')
  return `${version}${buildTime ? '@' + buildTime : ''}${
    commitId ? '@' + commitId : ''
  }`
}
